import React from 'react';

import { FormValidatorProvider } from '../../../form/ctx-provider/useFormValidatorCtx';
import WizardContent from './WizardContent';

const WizardPage: React.FC = () => {
    const onSubmit = (error: boolean) => {
    }

    return (
        <FormValidatorProvider onSubmit={onSubmit}>
            <WizardContent />
        </FormValidatorProvider>
    )
}

export default WizardPage;